import {
	glow,
	StyledCenter,
	StyledDecor,
	StyledGlow,
	StyledPriceBar,
	StyledRings,
	StyledShadowBottom,
	StyledShadowTop,
} from './CarPreviewDecor.styled';

const CarPreviewDecor = ({ withPriceBar }: { withPriceBar?: boolean }) => (
	<StyledDecor>
		<StyledCenter>
			<StyledGlow src={glow} alt="" />
			<StyledRings viewBox="0 0 500 500" fill="none">
				<circle cx="250" cy="250" r="49.5" stroke="#ffffff" opacity="0.02" />
				<circle cx="250" cy="250" r="149.5" stroke="#ffffff" opacity="0.05" />
				<circle cx="250" cy="250" r="249.5" stroke="#ffffff" opacity="0.02" />
			</StyledRings>
		</StyledCenter>
		<StyledShadowTop />
		<StyledShadowBottom />
		{withPriceBar && <StyledPriceBar />}
	</StyledDecor>
);

export { CarPreviewDecor };
